/* BizzyStitchn progressive enhancements for long-form content (.bz-prose) */
(function () {
  function enhance(root) {
    if (!root || root.dataset.bzEnhanced) return;
    root.dataset.bzEnhanced = '1';

    // 1. Scrollable, card-styled tables
    root.querySelectorAll('table').forEach(function (table) {
      if (table.parentElement.classList.contains('bz-table-wrap')) return;
      var wrap = document.createElement('div');
      wrap.className = 'bz-table-wrap';
      wrap.setAttribute('role', 'region');
      wrap.setAttribute('tabindex', '0');
      var caption = table.querySelector('caption');
      wrap.setAttribute('aria-label', caption ? caption.textContent.trim() : 'Table');
      table.parentNode.insertBefore(wrap, table);
      wrap.appendChild(table);
    });

    // 2. FAQ: an h2 that names "Frequently Asked Questions" (or "FAQ") followed by h3 + answer pairs
    root.querySelectorAll('h2').forEach(function (h2) {
      if (!/frequently asked|faq/i.test(h2.textContent)) return;
      var list = document.createElement('div');
      list.className = 'bz-faq-list';
      var node = h2.nextElementSibling;
      var current = null;
      var moved = [];
      while (node && node.tagName !== 'H2') {
        var next = node.nextElementSibling;
        if (node.tagName === 'H3') {
          current = document.createElement('details');
          current.className = 'bz-faq-item';
          var summary = document.createElement('summary');
          summary.appendChild(node); // keep the real <h3> for document outline
          current.appendChild(summary);
          var answer = document.createElement('div');
          answer.className = 'bz-faq-a';
          current.appendChild(answer);
          list.appendChild(current);
        } else if (current) {
          current.querySelector('.bz-faq-a').appendChild(node);
        } else {
          moved.push(node);
        }
        node = next;
      }
      if (list.children.length) {
        h2.insertAdjacentElement('afterend', list);
        moved.forEach(function (m) { list.insertAdjacentElement('beforebegin', m); });
        var first = list.querySelector('details');
        if (first) first.open = true;
      }
    });
  }

  function run() {
    document.querySelectorAll('.bz-prose').forEach(enhance);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
  document.addEventListener('shopify:section:load', run);
})();

/* #customize links: the 3D designer app's own loader opens the designer (since Oct 21). The theme's duplicate
   auto-click was removed Oct 30 (conflict C8) after a live test showed the app opens it on its own. */

/* Chat link: when a live-chat widget exposes window.BizzyBot.open(), open it instead of following the placeholder link */
document.addEventListener('click', function (e) {
  var a = e.target.closest && e.target.closest('[data-bz-chat]');
  if (!a) return;
  if (window.BizzyBot && typeof window.BizzyBot.open === 'function') { e.preventDefault(); window.BizzyBot.open(); }
});
